export function getStockIdentifierValues(
  isUsedVehicles: boolean,
  isUsMarket: boolean,
  lang: string,
) {
  return {
    stockCarsType: isUsedVehicles ? 'USED' : 'NEW',
    marketIdentifier: {
      language: lang,
      country: isUsMarket ? 'us' : 'ca',
      brand: 'A',
    },
  };
}
